export default __webpack_public_path__ + "static/flex-beat-gui-d1e43a80247309a7a7930d3cb54df543.png";